import React from "react";
import clsx from "clsx";
import SanityPortableText from "../SanityPortableText";

const StoryItwUI = ({ input }) => {
  // console.log(input);
  const {
    title,
    chapo,
    credits,
    interviewer,
    guest,
    questionsReponses
  } = input;

  const _getAccr = name => {
    if (!name) return "";
    let accr = "";
    const parts = name.split(" ").slice(0, 2);
    parts.forEach(element => {
      accr += element[0] + "";
    });

    return accr;
  };

  return (
    <section className='storyItwUI section '>
      <div className='inner'>
        <div className='scrollY'>
          <div className='px-sm md:p-md'>
            <h2 className='text-sm-lg md:text-lg mb-lg '>{title}</h2>
            {credits && typeof credits === "object" && (
              <div className='credits pl-50 md:pl-2/6 mb-lg'>
                <div className='row'>
                  {credits.map((el, i) => (
                    <div className={clsx(`col-md-${6 * el.column}`)} key={i}>
                      {el.texte}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {chapo && (
              <div className='chapo text-sm-lg md:text-lg md:mb-75 '>
                {chapo}
              </div>
            )}
            {/* <SanityPortableText input={texte} /> */}
            <ul className='questionsReponses '>
              {questionsReponses.map((qr, i) => (
                <li className={clsx("qr", i === 0 ? "qr-0" : "")} key={i}>
                  {i === 0 ? (
                    <>
                      <div className='qr-item mb-lg'>
                        <div className='interviewer accr text-sm-lg md:text-lg'>
                          {interviewer}
                        </div>

                        <div className='question w-full'>
                          <p className='pl-50 md:pl-2/6 pr-sm md:pr-md'>
                            {qr.question}
                          </p>
                        </div>
                      </div>

                      <div className='reponse'>
                        <div className='guest text-sm-lg md:text-lg'>
                          {guest}
                        </div>
                        <div className='reponse min-w-full '>
                          <SanityPortableText
                            input={qr.reponse}
                            indentP={true}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='qr-item md:flex items-baseline mb-lg'>
                        {/* <div className='interviewer accr uppercase text-sm-lg md:text-lg md:w-2/6 '>
                        {_getAccr(interviewer)}
                      </div> */}
                        <div className='interviewer accr uppercase text-sm-lg md:text-lg absolute top-0 h-full '>
                          <div className='sticky'>{_getAccr(interviewer)}</div>
                        </div>

                        <div className='question w-full'>
                          <p className='pl-50 md:pl-2/6 pr-sm md:pr-md'>
                            {qr.question}
                          </p>
                        </div>
                      </div>

                      <div className='qr-item md:flex items-baseline'>
                        <div className='guest accr uppercase text-sm-lg md:text-lg absolute top-0 h-full '>
                          <div className='sticky'>{_getAccr(guest)}</div>
                        </div>
                        <div className='reponse '>
                          <SanityPortableText
                            input={qr.reponse}
                            indentP={true}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryItwUI;
